webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(66)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(83),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-485f78eb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(68)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(85),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_intro__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Algorithm__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Algorithm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Algorithm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Papers__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Papers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Papers__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_intro___default.a
  }, {
    path: '/Algorithm/:AlgName',
    name: 'Algorithm',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Algorithm___default.a
  }, {
    path: '/Papers',
    name: 'Papers',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Papers___default.a
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    console.log(to, from, savedPosition);
    return { x: 0, y: 0 };
  }
}));

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(67)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(84),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TextChanger__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TextChanger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TextChanger__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



window.toClipboard = function () {
  var copyText = document.getElementById("bitcoinInput");
  copyText.select();
  document.execCommand("Copy");
  alert("Bitcoin Addres Copy on Clipboard");
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    TextChanger: __WEBPACK_IMPORTED_MODULE_0__components_TextChanger___default.a
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PubPerYear__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PubPerYear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PubPerYear__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      algorithmname: "",
      words: [],
      firstWords: [],
      randNum: 0,
      details: {},
      authors: []
    };
  },

  components: {
    PubPerYear: __WEBPACK_IMPORTED_MODULE_0__components_PubPerYear___default.a
  },
  mounted: function mounted() {
    var _this = this;

    this.algorithmname = this.$route.params.AlgName;
    axios.get('https://www.aeroreyna.com:8443/papers/countWords/' + this.algorithmname + '?limit=200').then(function (response) {
      response.data.forEach(function (w, i) {
        _this.words.push([w[0], i]);
        if (i < 20) {
          _this.firstWords.push(w);
        }
      });
      _this.words = _this.words.sort(function () {
        return 0.5 - Math.random();
      });
    }).catch(function (error) {
      console.log(error);
    });
    axios.get('https://www.aeroreyna.com:8443/list?query={%22title%22:%22' + this.algorithmname + '%22}').then(function (response) {
      _this.details = response.data[0];
    }).catch(function (error) {
      console.log(error);
    });
    setInterval(function () {
      _this.randNum = Math.floor(Math.random() * 100);
    }, 300);
    axios.get('https://www.aeroreyna.com:8443/papers/algorithmAuthors/' + this.algorithmname).then(function (response) {
      response.data.forEach(function (a) {
        _this.authors.push(a);
      });
    }).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      data: [],
      total: 0,
      page: 0,
      pages: 0,
      inverse: false,
      webQuery: {
        title: "",
        authors: "",
        year: "",
        pubtitle: ""
      },
      query: {}
    };
  },

  computed: {
    pagesList: function pagesList() {
      var initial = Math.max(this.page - 2, 1);
      var final = Math.min(this.pages, this.page + 5);
      var arr = [];
      for (var i = initial; i < final + 1; i++) {
        arr.push(i);
      }
      return arr;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.updateInfo();
    }
  },
  methods: {
    gotoPage: function gotoPage(i) {
      this.query.skip = (i - 1) * 10;
      this.pushRoute();
    },
    findAuthor: function findAuthor(author) {
      this.query.skip = 0;
      this.query.author = author;
      this.pushRoute();
    },
    pushRoute: function pushRoute() {
      this.$router.push({ name: "Papers", query: this.query });
      this.updateInfo();
    },

    updateInfo: function updateInfo() {
      var _this = this;

      var apiUrl = 'https://www.aeroreyna.com:8443/papers?';
      var params = [];
      var query = [];
      this.query = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$route.query));
      if (this.$route.query.algorithmname) query.push({ algorithmname: this.$route.query.algorithmname });
      if (this.$route.query.title) {
        query.push({ title: { $regex: this.$route.query.title, $options: "i" } });
      }
      if (this.$route.query.strict) {
        query.push({ title: { $regex: this.$route.query.algorithmname, $options: "i" } });
      }
      if (this.$route.query.author) {
        query.push({ authors: { "$elemMatch": { "$regex": this.$route.query.author } } });
      }
      if (this.$route.query.year) {
        query.push({ year: this.$route.query.year });
      }
      if (query) params.push('query={"$and":' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(query) + '}');
      if (this.$route.query.sort) params.push("sort={%22" + this.$route.query.sort + "%22:" + (this.$route.query.inverse ? -1 : 1) + "}");
      params.push("limit=" + 10);
      params.push("skip=" + (this.$route.query.skip || 0));
      apiUrl += params.join("&");
      console.log(apiUrl);
      axios.get(apiUrl).then(function (response) {
        //console.log(response)
        _this.data = response.data.docs;
        _this.total = response.data.count;
        _this.page = response.data.page + 1;
        _this.pages = response.data.totalPages;
        window.scrollTo(0, 0);
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  mounted: function mounted() {
    this.updateInfo();
    //console.log(this.$router)
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2__);

//
//
//
//

var Plotly = __webpack_require__(72);
var plotlyData = [];
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["algorithmname"],
  data: function data() {
    return {
      prevX: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    plotlyData = [];
    axios.get('https://www.aeroreyna.com:8443/papers/papersPerYear').then(function (response) {
      //console.log(response)
      var x = [],
          y = [],
          sizes = [],
          bestAl = [];
      response.data.forEach(function (v) {
        if (_this.algorithmname == "") {
          x.push(v._id.year);
          y.push(v.papers);
          sizes.push(6 + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2___default()(parseInt(v.papers)));
          bestAl.push(v.algorithms[0].algorithmname + " " + Math.floor(v.algorithms[0].countReferences / parseInt(v.papers) * 100) + "%");
        } else {
          v.algorithms.forEach(function (a) {
            if (a.algorithmname == _this.algorithmname) {
              x.push(v._id.year);
              y.push(a.countReferences);
              sizes.push(6 + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2___default()(parseInt(a.countReferences)));
              bestAl.push(a.algorithmname + " " + Math.floor(a.countReferences / parseInt(v.papers) * 100) + "%");
            }
          });
        }
      });
      plotlyData.push({
        x: x, y: y, type: 'scatter',
        mode: 'markers',
        hoverinfo: 'text',
        text: bestAl,
        marker: {
          color: 'rgba(129,207,224,1)',
          size: sizes
        },
        hoverlabel: {
          bgcolor: 'rgba(255,255,255,1)',
          bordercolor: 'rgba(150,150,150,0.2)',
          font: {
            color: 'rgb(0,0,0)'
          }
        }
      });
      Plotly.newPlot('graph', plotlyData);
      var myPlot = document.getElementById('graph');
      myPlot.on('plotly_click', function (data) {
        if (_this.prevX != data.points[0].x) {
          _this.prevX = data.points[0].x;
          Materialize.toast(data.points[0].y + ' articles, Click again to search them.', 4000);
          return;
        }
        if (!_this.algorithmname) {
          _this.$router.push({ name: "Papers", query: { year: data.points[0].x + "" } });
        } else {
          _this.$router.push({ name: "Papers", query: { year: data.points[0].x + "", algorithmname: _this.algorithmname } });
        }
      });
    }).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["arr"],
  data: function data() {
    return {
      i: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    var nextText = function nextText() {
      _this.i = _this.i < _this.arr.length - 1 ? _this.i + 1 : 0;
    };
    setInterval(nextText, 3000);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PubPerYear__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PubPerYear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PubPerYear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TextChanger__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TextChanger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_TextChanger__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      algorithms: [],
      randNum: 0,
      topDetail: [],
      filter: ""
    };
  },

  components: {
    PubPerYear: __WEBPACK_IMPORTED_MODULE_0__components_PubPerYear___default.a,
    TextChanger: __WEBPACK_IMPORTED_MODULE_1__components_TextChanger___default.a
  },
  mounted: function mounted() {
    var _this = this;

    axios.get('https://www.aeroreyna.com:8443/papers/count').then(function (response) {
      //console.log(response)
      response.data.forEach(function (v) {
        _this.algorithms.push(v);
      });
      _this.loading = false;
      axios.get('https://www.aeroreyna.com:8443/list?query={%22$or%22:[{%22title%22:%22' + _this.algorithms[0]._id.algorithmname + '%22},{%22title%22:%22' + _this.algorithms[1]._id.algorithmname + '%22},{%22title%22:%22' + _this.algorithms[2]._id.algorithmname + '%22}]}').then(function (response) {
        response.data.forEach(function (a) {
          _this.topDetail.push(a);
        });
      }).catch(function (error) {
        console.log(error);
      });
    }).catch(function (error) {
      console.log(error);
    });
    setInterval(function () {
      _this.randNum = Math.floor(Math.random() * 100);
    }, 300);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(19);
var $ = window.jQuery = __webpack_require__(2);
__webpack_require__(20);
__webpack_require__(21);
window.axios = __webpack_require__(18);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Abraham.8f9e7b8.png";

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Adolfo.5a9aaff.png";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(64)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(81),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-161d7531",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(69)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(86),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cb6755d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(65)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(82),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-367b5a15",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(63)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(80),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f7825ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appDiv"
  }, [_c('div', {
    staticClass: "container-fluid fullH",
    attrs: {
      "id": "intro"
    }
  }, [_c('div', {
    staticClass: "row center centerDiv"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('h1', [_vm._v("Loading")])]) : _vm._e(), _vm._l((_vm.algorithms), function(a, index) {
    return _c('div', {
      staticClass: "col backEffect",
      class: {
        active: _vm.randNum == index
      }
    }, [_c('p', [_c('router-link', {
      attrs: {
        "to": '/Algorithm/' + a._id.algorithmname
      }
    }, [_vm._v(_vm._s(a._id.algorithmname))])], 1)])
  })], 2), _c('div', {
    staticClass: "bigTitleDiv"
  }, [_c('h1', [_vm._v("AISearch")]), _c('h5', [_vm._v("Metaheuristics are"), _c('TextChanger', {
    attrs: {
      "arr": ['Nature Wisdom', 'a Mith?', 'Fun to Watch', 'Complicated', 'Mysterius']
    }
  })], 1)])]), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "PubPerYear"
    }
  }, [_c('h2', [_vm._v("Publications Per year")]), _c('h5', [_vm._v("Every year more and more scientific works make use of this algorithms")]), _c('br'), _c('PubPerYear', {
    attrs: {
      "algorithmname": ""
    }
  })], 1), (_vm.topDetail.length != 0) ? _c('div', {
    staticClass: "page",
    attrs: {
      "id": "HallOfFame"
    }
  }, [_c('h2', [_vm._v("Hall of Fame")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Algorithm',
          params: {
            AlgName: _vm.topDetail[0].title
          }
        })
      }
    }
  }, [(_vm.topDetail[0].imgUrl) ? _c('img', {
    staticClass: "circle",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "src": _vm.topDetail[0].imgUrl,
      "alt": "alt"
    }
  }) : _vm._e(), _c('h3', {
    staticClass: "metaName bold"
  }, [_vm._v(_vm._s(_vm.algorithms[0]._id.algorithmname))]), _c('h5', [_c('small', [_vm._v("by " + _vm._s(_vm.topDetail[0].author)), _c('br'), _c('small', [_vm._v(_vm._s(_vm.algorithms[0].count) + " References since " + _vm._s(_vm.algorithms[0].countYears[0].year))])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col m6 s12",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Algorithm',
          params: {
            AlgName: _vm.topDetail[2].title
          }
        })
      }
    }
  }, [(_vm.topDetail[1].imgUrl) ? _c('img', {
    staticClass: "circle",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "src": _vm.topDetail[1].imgUrl,
      "alt": "alt"
    }
  }) : _vm._e(), _c('h4', {
    staticClass: "metaName bold"
  }, [_vm._v(_vm._s(_vm.algorithms[1]._id.algorithmname))]), _c('h5', [_c('small', [_vm._v("by " + _vm._s(_vm.topDetail[2].author)), _c('br'), _c('small', [_vm._v(_vm._s(_vm.algorithms[1].count) + " References since " + _vm._s(_vm.topDetail[2].year))])])])]), _c('div', {
    staticClass: "col m6 s12",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Algorithm',
          params: {
            AlgName: _vm.topDetail[1].title
          }
        })
      }
    }
  }, [(_vm.topDetail[2].imgUrl) ? _c('img', {
    staticClass: "circle",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "src": _vm.topDetail[2].imgUrl,
      "alt": "alt"
    }
  }) : _vm._e(), _c('h4', {
    staticClass: "metaName bold"
  }, [_vm._v(_vm._s(_vm.algorithms[2]._id.algorithmname))]), _c('h5', [_c('small', [_vm._v("by " + _vm._s(_vm.topDetail[1].author)), _c('br'), _c('small', [_vm._v(_vm._s(_vm.algorithms[2].count) + " References since " + _vm._s(_vm.topDetail[1].year))])])])])])]) : _vm._e(), _c('div', {
    staticClass: "page fullH",
    attrs: {
      "id": "listAll"
    }
  }, [_c('h2', [_vm._v("List 'em All")]), _c('div', {
    staticClass: "container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "metaName bold",
    attrs: {
      "type": "text",
      "id": "filter",
      "placeholder": "Algorithm Name"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "row centerDiv"
  }, _vm._l((_vm.algorithms), function(a) {
    return (a._id.algorithmname.toLowerCase().includes(_vm.filter.toLowerCase())) ? _c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "card",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'Algorithm',
            params: {
              AlgName: a._id.algorithmname
            }
          })
        }
      }
    }, [_c('div', {
      staticClass: "card-content"
    }, [_c('p', {
      staticClass: "metaName bold"
    }, [_vm._v(_vm._s(a._id.algorithmname))])])])]) : _vm._e()
  }))])])
},staticRenderFns: []}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "AlgorithmPage fullH"
  }, [_c('div', {
    staticClass: "row centerDiv"
  }, [_vm._l((_vm.words), function(w, index) {
    return _c('div', {
      staticClass: "col backEffect",
      class: {
        active: _vm.randNum == w[1]
      },
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'Papers',
            query: {
              algorithmname: _vm.algorithmname,
              title: w[0]
            }
          })
        }
      }
    }, [_c('p', {
      style: ({
        fontSize: (24 - w[1] / 16) + 'px'
      })
    }, [_vm._v(_vm._s(w[0]))])])
  }), _c('div', {
    staticClass: "bigTitleDiv"
  }, [_c('h1', [_vm._v(_vm._s(_vm.algorithmname))]), _c('h5', [_vm._v("by " + _vm._s(_vm.details.author) + ", " + _vm._s(_vm.details.year))])])], 2)]), _c('div', {
    staticClass: "page"
  }, [_c('h2', [_vm._v("Details")]), _c('div', {
    staticClass: "container left-align"
  }, [(_vm.details.imgUrl) ? _c('img', {
    staticClass: "circle",
    staticStyle: {
      "width": "150px",
      "float": "right"
    },
    attrs: {
      "src": _vm.details.imgUrl,
      "alt": "alt"
    }
  }) : _vm._e(), _c('h3', {
    staticClass: "metaName"
  }, [_vm._v(_vm._s(_vm.algorithmname))]), _c('h5', [_c('small', [_vm._v("Author: " + _vm._s(_vm.details.author))])]), _c('h5', [_c('small', [_vm._v("Year of Publication: " + _vm._s(_vm.details.year))])]), _vm._m(0), _c('div', {
    staticClass: "abs"
  }, [_vm._v(_vm._s(_vm.details.abstract || 'No abstract available'))]), _c('p', {
    staticClass: "link center"
  }, [(_vm.details.urlPaper) ? _c('a', {
    attrs: {
      "href": _vm.details.urlPaper
    }
  }, [_vm._v("Read More")]) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col m6 s12"
  }, [_vm._m(1), (_vm.firstWords.length > 0) ? _c('center', [_c('p'), _vm._l((_vm.firstWords), function(w) {
    return _c('div', {
      staticClass: "chip",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'Papers',
            query: {
              algorithmname: _vm.algorithmname,
              title: w[0]
            }
          })
        }
      }
    }, [_vm._v(_vm._s(w[0])), _c('small', [_vm._v(" " + _vm._s(Math.floor(w[1] / _vm.firstWords[0][1] * 100) + "%"))])])
  }), _c('p')], 2) : _vm._e()], 1), _c('div', {
    staticClass: "col m6 s12"
  }, [_vm._m(2), _c('center', [_c('p'), _vm._l((_vm.authors), function(a, i) {
    return (a._id.authors && i < 20) ? _c('div', {
      staticClass: "chip",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'Papers',
            query: {
              algorithmname: _vm.algorithmname,
              author: a._id.authors
            }
          })
        }
      }
    }, [_vm._v(_vm._s(a._id.authors)), _c('small', [_vm._v(" " + _vm._s(a.count))])]) : _vm._e()
  }), _c('p')], 2)], 1)])])]), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "PubPerYear"
    }
  }, [_c('h2', [_vm._v("References per year")]), _c('br'), _c('PubPerYear', {
    attrs: {
      "algorithmname": _vm.algorithmname
    }
  }), _c('br')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('small', [_vm._v("Original Paper Abstract:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "center"
  }, [_c('small', [_vm._v("Most used words on titles works:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "center"
  }, [_c('small', [_vm._v("Authors refering this algorihtm:")])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "position": "relative",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col m3 s12 left-align"
  }, [_c('br'), _c('br'), _c('h1', [_vm._v("Papers")]), (_vm.$route.query.algorithmname) ? _c('p', [_vm._v("Algorithm: " + _vm._s(this.$route.query.algorithmname))]) : _vm._e(), (_vm.$route.query.title) ? _c('p', [_vm._v("Filter Title: " + _vm._s(this.$route.query.title))]) : _vm._e(), (_vm.$route.query.sort) ? _c('p', [_vm._v("Sort by: " + _vm._s(_vm.$route.query.sort))]) : _vm._e(), (_vm.$route.query.author) ? _c('p', [_vm._v("Author: " + _vm._s(_vm.$route.query.author))]) : _vm._e(), (_vm.query.algorithmname) ? _c('div', {
    staticClass: "strictSelector"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query.strict),
      expression: "query.strict"
    }],
    attrs: {
      "type": "checkbox",
      "id": "strict"
    },
    domProps: {
      "checked": Array.isArray(_vm.query.strict) ? _vm._i(_vm.query.strict, null) > -1 : (_vm.query.strict)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.query.strict,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.query.strict = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.query.strict = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.query.strict = $$c
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "strict"
    }
  }, [_vm._v("Strict")])]) : _vm._e(), _c('div', {
    staticClass: "sortBy"
  }, [_vm._l(([
    ['year', 'Year'],
    ['pubtitle', 'PubTitle']
  ]), function(a) {
    return _c('p', [_c('input', {
      staticClass: "with-gap",
      attrs: {
        "name": "sortBy",
        "type": "radio",
        "id": a[0]
      },
      domProps: {
        "checked": _vm.query.sort == a[0]
      }
    }), _c('label', {
      attrs: {
        "for": a[0]
      },
      on: {
        "click": function($event) {
          _vm.query.sort = a[0]
        }
      }
    }, [_vm._v(_vm._s(a[1]))])])
  }), _c('div', {
    staticClass: "switch"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query.inverse),
      expression: "query.inverse"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.query.inverse) ? _vm._i(_vm.query.inverse, null) > -1 : (_vm.query.inverse)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.query.inverse,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.query.inverse = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.query.inverse = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.query.inverse = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "lever"
  }), _vm._v("Inverse")])])], 2), _c('br'), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.query.skip = 0;
        _vm.pushRoute()
      }
    }
  }, [_vm._v("Update Search")])]), _c('div', {
    staticClass: "col m9 s12"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('p', [_c('small', [_vm._v(_vm._s(_vm.total) + " Articles found. Page " + _vm._s(_vm.page) + "/" + _vm._s(_vm.pages))])]), _vm._l((_vm.data), function(p, index) {
    return _c('div', {
      staticClass: "paper left-align"
    }, [_c('div', {
      staticClass: "col s12"
    }, [_c('p', [_c('b', [_c('a', {
      attrs: {
        "href": p.link,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(p.title))])]), _c('br'), _vm._l((p.authors), function(a) {
      return _c('span', [_c('a', {
        on: {
          "click": function($event) {
            _vm.findAuthor(a)
          }
        }
      }, [_vm._v(_vm._s(a) + ";")])])
    }), _c('br'), _c('small', [_vm._v(_vm._s(p.pubtitle))]), _c('br'), _c('small', [_vm._v("Year: " + _vm._s(p.year))]), (!_vm.query.algorithmname) ? _c('small', {
      on: {
        "click": function($event) {
          _vm.query.algorithmname = p.algorithmname;
          _vm.query.skip = 0;
          _vm.pushRoute()
        }
      }
    }, [_vm._v(", Reference to: " + _vm._s(p.algorithmname))]) : _vm._e()], 2)]), (index < _vm.data.length - 1) ? _c('hr') : _vm._e()])
  }), _c('div', {
    staticClass: "col s12"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    class: {
      disabled: _vm.page == 1
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.gotoPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_left")])])]), _vm._l((_vm.pagesList), function(i) {
    return _c('li', {
      class: {
        active: (i == parseInt(_vm.page))
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.gotoPage(i)
        }
      }
    }, [_vm._v(_vm._s(i))])])
  }), _c('li', {
    class: {
      disabled: _vm.page == _vm.pages
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.gotoPage(_vm.pages)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")])])])], 2)])], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "someDiv",
    attrs: {
      "id": 'graph'
    }
  })
},staticRenderFns: []}

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("AISearch")]), (_vm.$route.query.algorithmname) ? _c('router-link', {
    attrs: {
      "to": '/Algorithm/' + _vm.$route.query.algorithmname
    }
  }, [_vm._v(" > " + _vm._s(_vm.$route.query.algorithmname))]) : _vm._e(), _c('span', [_vm._v(" > " + _vm._s(_vm.$route.name))])], 1), _c('router-view'), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "Makers"
    }
  }, [_c('h2', [_vm._v("AISearch is brougth to you by:")]), _c('br'), _vm._m(0), _c('br'), _c('h5', [_vm._v("We"), _c('TextChanger', {
    attrs: {
      "arr": ['Code Algorithms', 'do Crazy Science', 'fight in Super Smash', 'Write Papers']
    }
  }), _vm._v("for food or"), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" donations")])], 1), _vm._m(1), _c('br'), _c('input', {
    staticStyle: {
      "opacity": "0"
    },
    attrs: {
      "id": "bitcoinInput",
      "type": "text",
      "value": "184zszakSnvM8ZpfJYwhoyppGdeiEdaKdB"
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col m6 s12"
  }, [_c('img', {
    staticClass: "profile circle responsive-img",
    attrs: {
      "src": __webpack_require__(75),
      "alt": "alt"
    }
  }), _c('h3', {
    staticClass: "metaName bold"
  }, [_c('a', {
    attrs: {
      "href": "https://www.researchgate.net/profile/Adolfo_Reyna_Orta",
      "target": "_blank"
    }
  }, [_vm._v("Adolfo Reyna Orta")])]), _c('p', [_vm._v("PhD Student of UABC, Mexicalli, Mexico.")]), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:aeroreyna@gmail.com"
    }
  }, [_vm._v("aeroreyna@gmail.com")])])]), _c('div', {
    staticClass: "col m6 s12"
  }, [_c('img', {
    staticClass: "profile circle responsive-img",
    attrs: {
      "src": __webpack_require__(74),
      "alt": "alt"
    }
  }), _c('h3', {
    staticClass: "metaName bold"
  }, [_vm._v("Fernando A. Fausto")]), _c('p', [_vm._v("PhD Student of UDG, Guadalajara, Mexico.")]), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:neosbreak@hotmail.com"
    }
  }, [_vm._v("neosbreak@hotmail.com")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('a', {
    attrs: {
      "href": "https://github.com/AISearch/AISearchBackend",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('span', {
    attrs: {
      "onclick": "toClipboard()"
    }
  }, [_vm._v(" "), _c('i', {
    staticClass: "fa fa-bitcoin",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('a', {
    attrs: {
      "href": "http://thesciencematrix.com/",
      "target": "_blank"
    }
  }, [_vm._v(" "), _c('i', {
    staticClass: "fa fa-rss",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(" " + _vm._s(_vm.arr[_vm.i] + " "))])
},staticRenderFns: []}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://forum.vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://gitter.im/vuejs/vue",
      "target": "_blank"
    }
  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuejs-templates.github.io/webpack/",
      "target": "_blank"
    }
  }, [_vm._v("Docs for This Template")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://router.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuex.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vue-loader.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/awesome-vue",
      "target": "_blank"
    }
  }, [_vm._v("awesome-vue")])])])
}]}

/***/ })
],[47]);


// WEBPACK FOOTER //
// static/js/app.abf3bde2cfcb470e8043.js